<template>
    <div class="row roles-list">
        <div class="col-xl-12 text-right mr-3 mb-3" v-if="user.role != 'ses-view'">
          <router-link :to="'/rolex/new'" class="btn">Add New</router-link>
        </div>
          <div class="col-xl-12">
              <div class="table-responsive projects-wrap">
                <base-table class="table align-items-center table-flush projects-table"
                            :class="'table-light'"
                            :thead-classes="'thead-light'"
                            tbody-classes="list"
                            :data="roles">
                  <template slot="columns">
                    <th class="text-left">#</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Type</th>
                    <th class="text-left">Role</th>
                    <th style="width:80px;" v-if="user.role != 'ses-view'">Actions</th>
                  </template>

                  <template slot-scope="{row}">
                    <td>{{ row.id }}</td>
                    <td>{{ row.name }}</td>
                    <td>{{ row.type }}</td>
                    <td>{{ row.role }}</td>
                    <td class="text-center" v-if="user.role != 'ses-view'"><router-link :to="'/rolex/'+row.id">Edit</router-link></td>
                  </template>

                </base-table>
                <div class="projects-list">
                    <div v-if="isLoading">Loading...</div>
                    <div v-else-if="!roles.length">No Roles Found</div>
                </div>
              </div>
          </div>
      </div>
</template>
<script>
  export default {
    name: 'roles',
    data() {
      return {
        apiUrl: '/api/',
        roles: []
      }
    },
    methods: {
        loadRoles() {
            var user = localStorage.getItem('user');
            if ( !user ) this.$router.push('login');
            this.user = JSON.parse(user);

            const api = this.apiUrl+'roles';
            this.isLoading = true;
            this.$http.get(api).then((response) => {
                this.isLoading = false;
                this.roles = response.data;
            });
        },
    },
    beforeMount(){
        this.loadRoles()
    }
  };
</script>
<style>
  .roles-list .projects-table { max-width: 100%; }
  .roles-list .projects-table th, .roles-list .projects-table td{ text-align: left; white-space: normal; }
  .roles-list .projects-table th{ text-align: center; background: #000; color: #FFF; }
  .roles-list .btn-wrap{ white-space: nowrap; margin-top: 4px; }
  .roles-list .btn{
    border-radius: 0;
    width: 120px;
    padding: 7px;
    border: 0;
    letter-spacing: .3px;
    color: #fff;
    font-size: 11px;
    text-decoration: none;
    background: #5bc0de;
    display: inline-block;
  }
  .roles-list .btn-success{ background: #5cb85c; }
  .roles-list .projects-table .vtop{ vertical-align: top; }
  .roles-list .projects-table .vright{ text-align: right; }
</style>
